import React, { useEffect } from 'react';
import Link from 'next/link';
import { Title } from '../Articles/styled';
import {
  AllToolsContainer,
  ToolContainer,
  ToolName,
  ToolWrapper,
  ViewAll,
} from './styled';
import ToolList from './ToolList';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';
import { useRouter } from 'next/router';
import {
  getToolsArrayAndLength,
  removeDefaultParams,
} from '../../../Utils/helper';
import { fireEvent } from '../../../Utils/fireEvent';

export default function Tools(props) {
  const {
    data,
    screen,
    heading,
    gridCount,
    requiredTools,
    ovulation,
    currentToolId,
  } = props;
  const router = useRouter();
  const { toolsarray, toolsLength } = getToolsArrayAndLength(
    data,
    currentToolId,
  );
  const viewAllHandler = () => {
    fireEvent({
      category: 'clicked_card_in_main_landing_page',
      screen_name: screen,
      card_name: 'View All Tools',
      deeplink_value: `/explore`,
      section_name: 'Tools',
    });
  };

  useEffect(() => {
    const contentIds = toolsarray?.map((item) => item?.name);
    fireServedSectionEvent(heading, contentIds, 'tools');
  }, []);
  return (
    <ToolContainer ovulation={ovulation}>
      <div>
        <Title>{heading}</Title>
      </div>
      <ToolWrapper gridCount={gridCount}>
        <ToolList data={toolsarray} screen={screen} />
        <Link
          href={{
            pathname: '/tools',
            query: removeDefaultParams(router.query),
          }}
          passHref
        >
          <AllToolsContainer onClick={viewAllHandler}>
            <ViewAll>
              <p>+{toolsLength}</p>
            </ViewAll>
            <ToolName>View All Tools</ToolName>
          </AllToolsContainer>
        </Link>
      </ToolWrapper>
    </ToolContainer>
  );
}
